<div id="sectionElement" class="center animatable reveal">
  <div class="section-info">
    <h2>Our Partners & Clients</h2>
    <div class="section-description">
      <!--      Companies that trust us as both a technology partner and a reliable outsourcing team.-->
      <div>Every company here represents a successful collaboration where our technical expertise has helped solve real
        business challenges.
      </div>
      <!--      From financial institutions to cultural organizations, we help our partners transform their ideas into functional and secure digital solutions.-->
      <div> We take pride in building long-term relationships with businesses and organizations that value quality
        engineering and dedicated support.
      </div>

    </div>
  </div>
  <div class="container">
    @for (partner of partners(); track partner.id) {
      <div class="partner"
           [style.boxShadow]="partner.color ? '0 0 20px ' + partner.color : '0 0 20px rgba(0, 0, 0, 0.2)'"
           [style.cursor]="partner.url ? 'pointer' : 'default'"
           (click)="partner?.url && openLink(partner?.url)"
           [matTooltip]="partner.name">
        <img [src]="partner?.logo?.url"/>
      </div>
    }
  </div>
</div>
